module.exports = __webpack_public_path__ + "img/c.938840c2.svg";